/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import styled from 'styled-components';
import { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { useAppSelector } from '../../redux/hooks';
import { selectGlobal } from '../../redux/state/globalSlice';

// Define your styled components
const InputWrapper = styled.div`
  margin: 1rem 0;
`;

const StyledLabel = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 2rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 40px;
`;

const InputReadOnlyAssistantFunctionType = (props: ControlProps) => {
  const { id, enabled, uischema, path, handleChange, data } = props;
  const global = useAppSelector(selectGlobal);
  const currentAssistant = global?.currentAssistant;

  return (
    <InputWrapper>
      <StyledLabel htmlFor={id}>Assistant Function Type</StyledLabel>
      <StyledInput
        id={id}
        type="text"
        value={
          currentAssistant?.function_type ||
          currentAssistant?.assistantTypeObject?.function_type
        }
        disabled={!enabled}
      />
    </InputWrapper>
  );
};

export default withJsonFormsControlProps(InputReadOnlyAssistantFunctionType);
